import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "main-content type4" };
const _hoisted_2 = { class: "content-wrapper" };
const _hoisted_3 = { class: "cy-notice-id title" };
const _hoisted_4 = { class: "option-ctrl-area" };
const _hoisted_5 = { class: "pb-3" };
const _hoisted_6 = { class: "py-3" };
const _hoisted_7 = { class: "py-3" };
const _hoisted_8 = { class: "pt-3 text-body wh-pl" };
import { onMounted, onUnmounted, } from 'vue';
import { routeName } from '@/constants/routeName';
import { useRoute, useRouter, } from 'vue-router';
import vuexStore from '@/vuex-store';
import CardSection from '@/components/Common/CardSection.vue';
import { storeToRefs } from 'pinia';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { i18n } from '@/locales';
import { alertActionType } from '@/vuex-store/alert/actions';
import AxiosResponse from '@/error/AxiosResponse';
import { autoLcWorkerNotice } from '@/locales/ko/views/worker_notice';
import { isTodayTextColor, formatDate, } from '@/utils';
import dateFormatType from '@/constants/dateFormatType';
import { pStore } from '@/pinia';
import BoardFooter from '@/components/Common/BoardFooter.vue';
import { BusinessError } from '@/error';
import SubController from './SubController.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        // PAGE: 총판점 공지사항 상세 조회
        const lc = autoLcWorkerNotice();
        const route = useRoute();
        const router = useRouter();
        const pWorkerNotice = pStore.piniaWorkerNotice;
        const { itemDetail } = storeToRefs(pWorkerNotice);
        const itemId = route.params.workerNoticeId;
        const _confirm = (payload) => vuexStore.dispatch(alertActionType.confirm, payload);
        /**
         * 삭제 핸들러
         */
        const handleClickDeleteBtn = async () => {
            const isConfirmOk = await _confirm({
                headerTitle: lc('delete_alert.head'),
                bodyContent: lc('delete_alert.body'),
            });
            if (!isConfirmOk) {
                return;
            }
            try {
                await pWorkerNotice.deleteNotice(itemId);
                vuexStore.dispatch(snackbarActionType.showSuccess, i18n.t('common.success'));
                router.push({
                    name: routeName.WORKER_NOTICE,
                });
            }
            catch (error) {
                console.log(error);
                vuexStore.dispatch(snackbarActionType.showSuccess);
            }
        };
        /**
         * 목록보기 클릭 핸들러
         */
        const handleClickReturnBtn = () => {
            router.push({
                name: routeName.WORKER_NOTICE,
            }).catch(() => { });
        };
        /**
         * 수정 클릭 핸들러
         */
        const handleClickEditBtn = () => {
            const name = routeName.WORKER_NOTICE_EDIT;
            const value = {
                params: {
                    workerNoticeId: itemId,
                },
                query: route.query,
            };
            router.push({
                name,
                ...value,
            }).catch(() => { });
        };
        onMounted(async () => {
            try {
                await pWorkerNotice.getNotice(itemId);
            }
            catch (error) {
                console.log('error', error);
                if (error instanceof BusinessError) {
                    if (error.status === 404) {
                        vuexStore.dispatch(snackbarActionType.showError, i18n.t('common.invalid_access'));
                        router.go(-1);
                    }
                }
                if (error instanceof AxiosResponse) {
                    if (error.status === 404) {
                        vuexStore.dispatch(snackbarActionType.showError, i18n.t('common.invalid_access'));
                        router.go(-1);
                    }
                }
            }
        });
        onUnmounted(() => {
            pWorkerNotice.clear();
        });
        return (_ctx, _cache) => {
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SubController),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(CardSection, null, {
                        titleContent: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(itemDetail).title), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(["item body2-text", _unref(isTodayTextColor)(_unref(itemDetail).createdAt)]),
                                    title: "작성일자"
                                }, _toDisplayString(_unref(formatDate)(_unref(itemDetail).createdAt, _unref(dateFormatType).FULL_DATE_MINUTE)), 3 /* TEXT, CLASS */)
                            ])
                        ]),
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(lc)('detail.user_name')) + " : " + _toDisplayString(_unref(itemDetail).userName), 1 /* TEXT */),
                            _createVNode(_component_v_divider),
                            _createElementVNode("div", _hoisted_6, [
                                _createTextVNode(_toDisplayString(_unref(lc)('detail.period')) + " : ", 1 /* TEXT */),
                                (_unref(itemDetail).noticePeriodType === 'SELECTED')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_unref(formatDate)(_unref(itemDetail).noticeStart, _unref(dateFormatType).FULL_DATE_MINUTE)) + " ~ " + _toDisplayString(_unref(formatDate)(_unref(itemDetail).noticeEnd, _unref(dateFormatType).FULL_DATE_MINUTE)), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true),
                                (_unref(itemDetail).noticePeriodType === 'ENDLESS')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_unref(lc)('detail.endless')), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _createVNode(_component_v_divider),
                            _createElementVNode("div", _hoisted_7, [
                                _createTextVNode(_toDisplayString(_unref(lc)('detail.target_worker')) + " : ", 1 /* TEXT */),
                                (_unref(itemDetail).workerNoticeTargetType === 'BY_WORKER')
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(itemDetail).selectedWorkerList, ({ code, name }, key) => {
                                        return (_openBlock(), _createBlock(_component_v_chip, {
                                            key: key,
                                            title: code,
                                            class: "ml-1",
                                            color: "primary",
                                            variant: "outlined"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(name), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                    : _createCommentVNode("v-if", true),
                                (_unref(itemDetail).workerNoticeTargetType === 'WORKER_OF_DISTRIBUTOR')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_unref(lc)('detail.target_dist_all_worker')), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true),
                                (_unref(itemDetail).workerNoticeTargetType === 'WORKER_OF_HUB')
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 2,
                                        title: _unref(itemDetail).hub.code,
                                        class: "mr-1",
                                        color: "primary",
                                        variant: "outlined"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(itemDetail).hub.name) + " " + _toDisplayString(_unref(lc)('detail.target_hub_all_worker')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["title"]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _createVNode(_component_v_divider),
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(itemDetail).body), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _createVNode(BoardFooter, null, {
                    left: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickReturnBtn }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { small: "" }, {
                                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                                        _createTextVNode(" mdi-chevron-left ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [0]
                                }),
                                _createTextVNode(" " + _toDisplayString(_unref(lc)('back_to_list')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    info: true,
                                    outlined: true,
                                    "size-l": true,
                                    "width-xs": true
                                }
                            ]
                        ])
                    ]),
                    right: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            class: "item",
                            onClick: handleClickDeleteBtn
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { small: "" }, {
                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                        _createTextVNode(" mdi-trash-can-outline ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [1]
                                }),
                                _createTextVNode(" " + _toDisplayString(_unref(lc)('delete')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    danger: true,
                                    outlined: true,
                                    "size-l": true,
                                    "width-xs": true
                                }
                            ]
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            class: "cy-edit-btn item",
                            onClick: handleClickEditBtn
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { small: "" }, {
                                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                                        _createTextVNode(" mdi-pencil-outline ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [2]
                                }),
                                _createTextVNode(" " + _toDisplayString(_unref(lc)('edit')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    info: true,
                                    outlined: true,
                                    "size-l": true,
                                    "width-xs": true
                                }
                            ]
                        ])
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
